import { LOGOUT_USER } from "../../ActionTypes";

export const logoutApp = (history) => (dispatch) => {
  history.push("/");
  sessionStorage.removeItem("token");
  dispatch({ type: LOGOUT_USER });
  localStorage.removeItem("isAdmin"); 
  localStorage.removeItem("token");   
};
